'use strict';
import env from '../constants/environment';

export const features = {
	startDates: env.FEATURE_START_DATES,
	groups: env.FEATURE_GROUPS,
	preferences: env.FEATURE_PREFERENCES,
	feature30Day: env.FEATURE_30DAY,
};

export const hasFeature = (featureName, user) => {
	var has = false;
	const cyf = user.profile.stripeSubscriptionId && user.profile.stripeSubscriptionId !== null;
	if (user !== null && user.profile !== null && user.profile.isAuthenticated && user.profile.email) {
		if (features[featureName].indexOf(',') >= 0) {
			var options = features[featureName].split(',');
			has = options.indexOf(user.profile.email.toLowerCase()) >= 0;
			if (!has && user.profile.isAdmin) {
				has = options.indexOf('admin') >= 0;
			}
			if (!has && cyf === true) {
				has = options.indexOf('cyf') >= 0;
			}
		}
		else if (features[featureName] === user.profile.email) {
			has = true;
		}
		else {
			has = features[featureName] === 'true' || (user.profile.isAdmin && features[featureName] === 'admin') || (cyf && features[featureName] === 'cyf');
		}
	}
	else {
		has = features[featureName] === 'true';
	}
	return has;
}